/*
 * PokeAlp · Oct. 2026 : option "Envoi avec signature" dans le panier.
 * Le snippet shipping-protection.liquid rend <pa-signature-toggle>.
 * Ce script :
 *  1. place le composant juste au-dessus du récap (panier latéral et page panier),
 *  2. ajoute / retire le produit signature du panier quand on bascule l'interrupteur,
 *  3. retire le produit signature s'il reste seul dans le panier.
 */
(function () {
  'use strict';
  if (window.customElements.get('pa-signature-toggle')) return;

  var cfg = window.paSignature || {};
  /* Noms des évènements du thème (assets/events.js, module @theme/events) */
  var EVENTS = { cartReload: 'cart:reload', cartUpdate: 'cart:update', currencyUpdate: 'currency:update' };
  function ev() {
    return EVENTS;
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function emit(name) {
    if (name) document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
  }

  function updateCart(variantId, quantity) {
    var updates = {};
    updates[variantId] = quantity;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/update ' + res.status);
      return res.json();
    });
  }

  function reloadCart() {
    emit(ev().cartReload);
  }

  class PaSignatureToggle extends HTMLElement {
    connectedCallback() {
      if (this._paReady) return;
      this._paReady = true;
      this.input = this.querySelector('.pa-sig__input');
      if (!this.input) return;
      this.input.addEventListener('change', this.onChange.bind(this));
      this.place();
    }

    get variantId() {
      return this.getAttribute('data-variant-id');
    }

    place() {
      var target = null;
      if (this.dataset.context === 'cart') {
        var page = this.closest('#hdt-page-cart') || document;
        target = page.querySelector('.pa-cart-card--summary .pa-summary-totals');
      } else {
        var drawer = this.closest('#CartDrawer');
        target = drawer && drawer.querySelector('.hdt-mini-cart__bottom-wrap .hdt-mini-cart__recap');
      }
      if (!target || !target.parentNode) return;
      var self = this;
      Array.prototype.forEach.call(target.parentNode.children, function (el) {
        if (el !== self && el.tagName === 'PA-SIGNATURE-TOGGLE') el.remove();
      });
      target.parentNode.insertBefore(this, target);
    }

    onChange() {
      var on = this.input.checked;
      var self = this;
      this.classList.toggle('is-on', on);
      this.classList.add('is-loading');
      this.input.disabled = true;
      emit('theme:loading:doing');
      updateCart(this.variantId, on ? 1 : 0)
        .then(function () {
          reloadCart();
        })
        .catch(function (err) {
          console.error('[PokeAlp signature]', err);
          self.input.checked = !on;
          self.classList.toggle('is-on', !on);
        })
        .finally(function () {
          emit('theme:loading:done');
          emit(ev().currencyUpdate);
          self.classList.remove('is-loading');
          self.input.disabled = false;
        });
    }
  }

  window.customElements.define('pa-signature-toggle', PaSignatureToggle);

  /* Nettoyage : la signature ne doit jamais rester seule dans le panier */
  var vid = cfg.variantId ? String(cfg.variantId) : null;
  var cleaning = false;

  function onlySignature(items) {
    if (!vid || !items || !items.length) return false;
    return items.every(function (item) {
      return String(item.variant_id || item.id) === vid;
    });
  }

  function removeSignature() {
    if (cleaning || !vid) return;
    cleaning = true;
    updateCart(vid, 0)
      .then(reloadCart)
      .catch(function (err) { console.error('[PokeAlp signature]', err); })
      .finally(function () { cleaning = false; });
  }

  function boot() {
    if (cfg.onlyItem) removeSignature();
    var EV = ev();
    if (EV.cartUpdate) {
      document.addEventListener(EV.cartUpdate, function (event) {
        try {
          var items = event.detail && event.detail.cartData && event.detail.cartData.items;
          if (onlySignature(items)) removeSignature();
        } catch (e) { /* rien */ }
      });
    }
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
})();
